const _ = require('./status/enum');

module.exports = [
  _.AUTHENTICATION_REQUEST_FAILED,
  _.AUTHENTICATION_REQUESTED,
  _.AUTHORIZATION_REQUEST_FAILED,
  _.AUTHORIZATION_REQUESTED,
  _.AUTHORIZATION_CANCEL_REQUEST_FAILED,
  _.AUTHORIZATION_CANCEL_REQUESTED,
  _.CAPTURE_REQUEST_FAILED,
  _.CAPTURE_REQUESTED,
  _.REFUND_REQUEST_FAILED,
  _.REFUND_REQUESTED,
];
